// EMERGENCY: Disabled all Realtime subscriptions to reduce Supabase egress
// This hook is now a no-op — it accepts the same parameters but does nothing.
// Re-enable once egress is under control.

export function useRealtimeRefresh(_tables: string[], _onRefresh: () => void) {
  // No-op: Realtime disabled to reduce egress
}
